import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserAuthResponse } from "../../shared/dtos/auth/UserAuthResponse";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";
import { UserStatus } from "../../shared//enums/UserStatus";

export interface AuthState {
  loadingUserInfo: boolean;
  loadingUserVerify: boolean;
  loadingForgotPassword: boolean;
  loadingResetPassword: boolean;

  errorLoadingUserInfo: string | null;
  errorUserVerify: string | null;
  errorForgotPassword: string | null;
  errorResetPassword: string | null;

  userInfo: UserAuthResponse["userData"] | null;
  serverStatus: ServerStatusPayload | null;
}

const initialState: AuthState = {
  loadingUserInfo: false,
  loadingUserVerify: false,
  loadingForgotPassword: false,
  loadingResetPassword: false,

  errorLoadingUserInfo: null,
  errorUserVerify: null,
  errorForgotPassword: null,
  errorResetPassword: null,

  userInfo: null,
  serverStatus: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoadingUserInfo(state) {
      state.loadingUserInfo = true;
      state.errorLoadingUserInfo = null;
    },
    setLoadingUserVerify(state) {
      state.loadingUserVerify = true;
      state.errorUserVerify = null;
    },
    setLoadingForgotPassword(state) {
      state.loadingForgotPassword = true;
      state.errorForgotPassword = null;
    },
    setLoadingResetPassword(state) {
      state.loadingResetPassword = true;
      state.errorResetPassword = null;
    },

    setErrorLoadingUserInfo(state, action: PayloadAction<string | null>) {
      state.loadingUserInfo = false;
      state.errorLoadingUserInfo = action.payload;
    },
    setErrorUserVerify(state, action: PayloadAction<string | null>) {
      state.loadingUserVerify = false;
      state.errorUserVerify = action.payload;
    },
    setErrorForgotPassword(state, action: PayloadAction<string | null>) {
      state.loadingForgotPassword = false;
      state.errorForgotPassword = action.payload;
    },
    setErrorResetPassword(state, action: PayloadAction<string | null>) {
      state.loadingResetPassword = false;
      state.errorResetPassword = action.payload;
    },

    userLoginSuccess(
      state,
      action: PayloadAction<UserAuthResponse["userData"]>,
    ) {
      state.userInfo = action.payload;
      state.loadingUserInfo = false;
      state.errorLoadingUserInfo = null;
    },
    userLogout(state) {
      state.userInfo = null;
      state.loadingUserInfo = false;
      state.errorLoadingUserInfo = null;
    },
    verifyUserEmailSuccess(state) {
      state.loadingUserVerify = false;
      if (state.userInfo) {
        state.userInfo.status = UserStatus.ACTIVE;
      }
    },
    forgotPasswordSuccess(state) {
      state.loadingForgotPassword = false;
    },
    resetPasswordSuccess(state) {
      state.loadingResetPassword = false;
    },

    setServerResponseStatus(
      state,
      action: PayloadAction<ServerStatusPayload | null>,
    ) {
      state.serverStatus = action.payload;
    },
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
